import React, { useState, useEffect } from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import { apiUrl } from "../commons/inFormTypes";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loaders from "../components/Loaders";
import { useUserSession } from "../components/user-context";
import { zoomIn } from "react-animations";
import Radium, { StyleRoot } from "radium";
import LoaderBtn from "../components/LoaderBtn";
import { handleEnter } from "../components/CommonFunections";
import CustomInput from "../components/CustomInput";

function Profile() {
  const [codeMeli, setCodeMeli] = useState("");
  const [mobile, setMobile] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [load, setLoad] = useState(true);
  const [snip, setSnip] = useState(false);
  const userToken = localStorage.getItem("user_token");
  const { logIn } = useUserSession();


  const styles = {
    zoomIn: {
      animation: "x 1s",
      animationName: Radium.keyframes(zoomIn, "zoomIn"),
    },
  };

  useEffect(() => {
    const axios = require("axios");
    axios({
      method: "post",
      url: apiUrl + "userinfo",
      headers: {
        'Access-Control-Allow-Origin': "*",
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + userToken,

      }
    })
      .then((res) => {
        if (res.data.success) {
          setFirstName(res.data.result.firstname)
          setLastName(res.data.result.lastname)
          setCodeMeli(res.data.result.nationalcode)
          setMobile(res.data.result.mobile)
        } else {
        }
      })
      .catch(function (error) {
        console.log(error);
      });

  }, []);

  const registerHandler = (e) => {
    e.preventDefault();
    if (
      mobile.length < 11 ||
      mobile === "" ||
      !mobile.startsWith("09") ||
      codeMeli === " " ||
      codeMeli.length < 10 ||
      codeMeli.length > 10 ||
      firstName === " " ||
      lastName === " "
    ) {
      toast.error("لطفا اطلاعات را وارد کنید", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
      return false;
    } else {
      const axios = require("axios");
      var data = new FormData();
      data.append('firstname', firstName);
      data.append('lastname', lastName);
      data.append('mobile', mobile);
      data.append('address', '1');
      data.append('nationalcode', codeMeli);
      setSnip(true);
      // setLoad(false);
      axios({
        method: "post",
        url: apiUrl + "profile",
        headers: {
          'Access-Control-Allow-Origin': "*",
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + userToken,
          // ...data.getHeaders()
        },
        data: data
      })
        .then((res) => {
          setSnip(false);
          // setLoad(true);
          if (res.data.success) {
            localStorage.setItem("user_namefamily", res.data.result.full_name);
            logIn(localStorage.getItem("user_namefamily"));
            toast.success("ثبت با موفقیت انجام شد", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
    }
  };

  //enter for input insted of click button submitHandler function
  const keyPress = (e) => {
    if (e.keyCode === 13) {
      registerHandler(e)
    }
  }



  return (
    <div>
      <Container className="pt-5">
        <StyleRoot>
          <div className="test" style={styles.zoomIn}>
            <Row className="justify-content-center">
              <Col xs={11} lg={8} className="rgc-request p-4">
                <h4 className="text-center pb-3">مشخصات کاربر</h4>
                <Form>
                  <div>
                    <Row className="justify-content-center">
                      <Col className="pl-1" lg="5">
                        <CustomInput
                          icon={"fas fa-user-alt"}
                          label={"نام"}
                          type={"text"}
                          value={firstName}
                          placeholder={"نام"}
                          onChange={(event) => setFirstName(event.target.value)}
                          onKeyDown1={handleEnter}
                        />
                      </Col>

                      <Col className="pl-1" lg="5">
                        <CustomInput
                          icon={"fas fa-user-circle"}
                          label={"نام خانوادگی"}
                          type={"text"}
                          value={lastName}
                          placeholder={"نام خانوادگی"}
                          onChange={(event) => setLastName(event.target.value)}
                          onKeyDown1={handleEnter}
                        />
                      </Col>

                     

                      <Col className="pl-1" lg="5">
                      <CustomInput
                          icon={"fa fa-id-card"}
                          label={"کد ملی"}
                          type={"number"}
                          value={codeMeli}
                          placeholder={"کد ملی"}
                          onChange={(event) => setCodeMeli(event.target.value)}
                          onKeyDown1={handleEnter}
                        />                       
                      </Col>

                      <Col className="pl-1" lg="5">

                      <CustomInput
                          icon={"fas fa-mobile-alt"}
                          label={"شماره همراه"}
                          type={"number"}
                          value={mobile}
                          placeholder={"شماره همراه"}
                          onChange={(event) => setMobile(event.target.value)} 
                          onKeyDown1={handleEnter}                                              
                        /> 

                      </Col>

                      <Col xs="12" className="btnStyle text-center">
                        <Button
                          type="submit"
                          className="rgc-btn rgc-follow-btn py-3"
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onClick={registerHandler}
                        >
                          <LoaderBtn loads={snip} />
                          <span>  ثبت اطلاعات</span>
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        </StyleRoot>
      </Container>
      <div className="rgc-toast">
        <ToastContainer autoClose={3000} />
      </div>
      <Loaders loads={load} />
    </div>
  );
}

export default Profile;
